import { withChartLayout } from 'components/common';
import ManiaQuestionnaire from 'components/features/chart/special-charts/mania-questionnaire/ManiaQuestionnaire';

const ManiaQuestionnairePage = withChartLayout('Mania Questionnaire')(ManiaQuestionnaire);
export default ManiaQuestionnairePage;
